import { NgxsModule, Store } from '@ngxs/store';

import { CapaciteService } from './latest/services/capacite-service/capacite-service.service';
import { CapaciteState } from './latest/capacite.state';
import { NgModule } from '@angular/core';
import { ToolCapaciteService } from './tool-capacite.service';
import { ToolCapaciteVersionService } from './tool-capacite-version.service';

@NgModule({
  imports: [NgxsModule.forFeature([CapaciteState])],
  providers: [
    {
      provide: ToolCapaciteService,
      useFactory: toolCapaciteServiceFactory,
      deps: [ToolCapaciteVersionService, Store]
    }
  ]
})
export class ToolCapaciteStateModule {}

function toolCapaciteServiceFactory(store: Store) {
  return new CapaciteService(store);
}
